import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FinalidadesService } from '../../services/finalidades.service';

@Component({
  selector: 'app-finalidades-edit',
  templateUrl: './finalidades-edit.component.html',
  styleUrls: ['./finalidades-edit.component.scss']
})
export class FinalidadesEditComponent implements OnInit {

  finalidadForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
      private _FinalidadesService: FinalidadesService, private _authService: AuthService, private _router: Router,
      public dialogRef: MatDialogRef<FinalidadesService>,
      private _location: Location) {
    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.finalidadForm = this._fb.group({
      id: 0,
      nombre: ['', Validators.required],
      nombre_PT: ['', Validators.required],
      codFinalidad: ['', Validators.required],
      updatedBy: [''],
      createdBy: [''],
      updatedDate: [''],
      createdDate: [new Date()],
      createdByName: [''],
      updatedByName: ['']
    });
  }

  ngOnInit() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      this._FinalidadesService.getFianlidadById(this.id)
        .subscribe(resp => {
          this.finalidadForm.setValue(resp);
        }, error => { this.errorMessage = error; });
    } else {
      this.isNewElement = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    if (!this.finalidadForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._FinalidadesService.createFinalidad(this.finalidadForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error);
    } else {
      this._FinalidadesService.updateFinalidad(this.id, this.finalidadForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
        }, error => this.errorMessage = error);
    }
  }

  get codFinalidad() { return this.finalidadForm.get('codFinalidad'); }
  get nombre() { return this.finalidadForm.get('nombre'); }
  get nombre_PT() { return this.finalidadForm.get('nombre_PT'); }
}
